import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue"
import router from "@/router";
import { uitlsToLiveRoom } from "@/uitls/uitls";


interface dataProps {
    item: any;
}

export default /*#__PURE__*/_defineComponent({
  name: 'MatchCell',
  props: {
    item: { type: null, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    item: any;
}


const livezb = require(`@/assets/${process.env.VUE_APP_NAME}/live-gif.gif`)
const liveys = require(`@/assets/${process.env.VUE_APP_NAME}/live-ys-gif.gif`)
const livepb = require(`@/assets/${process.env.VUE_APP_NAME}/live_pb.gif`)


onMounted(() => {

})

const toLiveRoom = (data) => {
    uitlsToLiveRoom(data, router)
};

//判断有主播的，还是清源
const checkZb = (data) => {
    if (data.live_type == 1) {
        //有主播的
        return 0;
    } else if (
        data.live_type == 2
    ) {
        //清源
        return 0;
    } else {
        //mp4
        return 2
    }
}


const __returned__ = { livezb, liveys, livepb, props, toLiveRoom, checkZb }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})